import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import LockUnlockNpRent from './LockUnlockNpRent';
import LockUnlockNpRentBlockData from '../../../Models/Content/LockUnlockNpRentBlockData';

export default class LockUnlockNpRentBlock extends EpiComponent<LockUnlockNpRentBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <LockUnlockNpRent iContent={this.props.data} context={this.getContext()} />;
  }
}